/**
 * Single shared SIMULATION clock, in seconds, advanced by the game loop from the CLAMPED frame
 * delta (`simClock.now += min(realDelta, 0.05)`).
 *
 * All GAMEPLAY timing reads this — entity AI timers, fire/threat windows, village "under attack"
 * stamps, wave-intro timing — so motion (which integrates the same clamped dt) and the timers that
 * gate it stay consistent even when the frame rate tanks: the whole simulation slows together
 * instead of timers racing ahead of motion (which is what made AI disengage early and made
 * cross-clock comparisons drift at low FPS).
 *
 * UI, audio and purely-cosmetic animation deliberately keep using `performance.now()` — those
 * should track REAL wall-clock time even while the sim is running in slow-motion.
 *
 * It starts at 0 and only ever increases, so every gameplay comparison must be a DELTA
 * (`simClock.now - someStamp`); never compare a sim stamp against a `performance.now()` value.
 */
export const simClock = { now: 0 };
